export default class DymoService {
  static initFramework () {
    return new Promise((resolve, reject) => {
      const plugin = document.createElement('script')
      plugin.setAttribute('src', 'js/dymo-framework.js')
      plugin.async = true
      plugin.onload = () => {
        if (window.dymo && window.dymo.label && window.dymo.label.framework) {
          window.dymo.label.framework.init()
          if (!window.dymo.label.framework.checkEnvironment()) {
            reject('Dymo environment invalid')
          } else {
            resolve('DYMO framework initialized successfully.')
          }
        } else {
          reject('DYMO framework not loaded correctly.')
        }
      }
      plugin.onerror = () => reject('DYMO framework failed to load.')
      document.head.appendChild(plugin)
    })
  }

  static createLabel (fileName) {
    const label = window.dymo.label.framework.openLabelFile(fileName)

    if (label.isDCDLabel())
			console.log("DYMO Connect label")
		if (label.isDLSLabel())
			console.log("DLS label");	
		if (label.isValidLabel())
			console.log("The file is a valid label")
		else {
			alert(" The file is not a valid label")
			return;
		}

    return label
  }

  static previewLabel (labelXml) {
    const printers = window.dymo.label.framework.getPrinters()
    if (printers.length === 0) {
      throw 'No DYMO printers are connected.'
    }
    const printerName = printers[0].name
    return window.dymo.label.framework.renderLabel(labelXml, null, printerName)
  }

  static printLabel (labelXml) {
    const printers = window.dymo.label.framework.getPrinters()
    if (printers.length === 0) {
      throw 'No DYMO printers are connected.'
    }
    const printerName = printers[0].name
    return window.dymo.label.framework.printLabel(printerName, null, labelXml, null)
  }
}
